import React, { useState } from "react";
import { create } from "zustand";
import DataListStore from "../../store/DataListStore";
import ListViewV2 from "../App/DataListV2";
import { UpdateStatusPesanan } from "services/datalist/datalist-api";
import {
  Card,
  Collapse,
  Descriptions,
  List,
  notification,
  Space,
  Spin,
  Tag,
  Typography,
} from "antd";

import { CheckOutlined, CalendarOutlined } from "@ant-design/icons";
import { ClickLoadingButton } from "components/buttons/ClickLoadingButton";
import { GetDataKeepan } from "services/datalist/datalist-api";

const defaultDataStore = create(DataListStore);
const { Text } = Typography;
const { Panel } = Collapse;

const PesananSiapKirim = () => {
  const [historyMap, setHistoryMap] = useState({});
  const [loadingMap, setLoadingMap] = useState({});

  const fetchHistory = async (key) => {
    setLoadingMap((prev) => ({ ...prev, [key]: true }));

    try {
      // simulasi API fetch
      const result = await GetDataKeepan(key);

      setHistoryMap((prev) => ({ ...prev, [key]: result }));
    } finally {
      setLoadingMap((prev) => ({ ...prev, [key]: false }));
    }
  };

  let user = localStorage.getItem("auth-id");
  const userObj = JSON.parse(user);

  return (
    <ListViewV2
      viewId={"bcsiapkirim"}
      store={defaultDataStore}
      expandable={{
        expandedRowRender: (record) => {
          return (
            <Card
              title={
                <Space>
                  <span>Detail Pesanan</span>
                  <Tag color={"green"}>{record.Status}</Tag>
                </Space>
              }
              bordered
            >
              <Descriptions
                size="small"
                bordered
                column={{ xs: 1, sm: 1, md: 2, lg: 2 }}
              >
                <Descriptions.Item label="Nama">
                  {record.Nama}
                </Descriptions.Item>
                <Descriptions.Item label="Target (WA)">
                  +{record.Target}
                </Descriptions.Item>
                <Descriptions.Item label="Tanggal">
                  {new Date(record.TglTransaksi).toLocaleDateString("id-ID")}
                </Descriptions.Item>
                <Descriptions.Item label="Pesanan">
                  {record.Pesanan}
                </Descriptions.Item>
                <Descriptions.Item label="Tagihan">
                  Rp {record.SubTotal.toLocaleString("id-ID")}
                </Descriptions.Item>
              </Descriptions>

              <Collapse bordered={false} style={{ marginTop: 16 }}>
                <Panel header="Data Keepan" key="1">
                  {loadingMap[record.Target] ? (
                    <Spin tip="Memuat Pesanan..." />
                  ) : (
                    <List
                      itemLayout="horizontal"
                      dataSource={historyMap[record.Target] || []}
                      locale={{ emptyText: "Tidak ada Keepan" }}
                      renderItem={(item) => (
                        <List.Item>
                          <List.Item.Meta
                            title={
                              <Space>
                                <CalendarOutlined />
                                <Text strong>
                                  {new Date(
                                    item.TglTransaksi
                                  ).toLocaleDateString("id-ID")}
                                </Text>
                                {item.SendFlag ? (
                                  <Tag color={"green"}>{"Sudah Dikirim"}</Tag>
                                ) : (
                                  <Tag color={"red"}>{"Belum Dikirim"}</Tag>
                                )}
                              </Space>
                            }
                            description={
                              <Card
                                type="inner"
                                title="Informasi Penyimpanan & Pengiriman"
                                style={{ marginTop: 16 }}
                              >
                                <p>{item.Pesanan}</p>
                                <Descriptions
                                  size="small"
                                  bordered
                                  column={{ xs: 1, sm: 1, md: 2, lg: 2 }}
                                >
                                  <Descriptions.Item label="Di Keep Oleh">
                                    {item.updateBy}
                                  </Descriptions.Item>
                                  <Descriptions.Item label="Tempat Penyimpanan">
                                    {item.Placement}
                                  </Descriptions.Item>
                                  <Descriptions.Item label="Disimpan Oleh">
                                    {item.KeptBy}
                                  </Descriptions.Item>
                                  <Descriptions.Item label="Tanggal Simpan">
                                    {item.KeptDate
                                      ? new Date(
                                          item.KeptDate
                                        ).toLocaleDateString("id-ID")
                                      : "-"}
                                  </Descriptions.Item>
                                  <Descriptions.Item label="Request Diambil Oleh">
                                    {item.RequestBy}
                                  </Descriptions.Item>
                                  <Descriptions.Item label="Dikeluarkan Oleh">
                                    {item.TakeBy || "-"}
                                  </Descriptions.Item>
                                  <Descriptions.Item label="Tanggal Dikeluarkan">
                                    {item.SendDate
                                      ? new Date(
                                          item.SendDate
                                        ).toLocaleDateString("id-ID")
                                      : "-"}
                                  </Descriptions.Item>
                                </Descriptions>
                              </Card>
                            }
                          />
                        </List.Item>
                      )}
                    />
                  )}
                </Panel>
              </Collapse>
            </Card>
          );
        },
        onExpand: (expanded, record) => {
          if (expanded && !historyMap[record.Target]) {
            fetchHistory(record.Target); // ambil data async ketika expand pertama kali
          }
        },
        rowExpandable: () => true,
      }}
      customRowAction={(props) => (
        <Space style={{ display: "flex", justifyContent: "left" }}>
          <ClickLoadingButton
            title="Ceklist Pesanan"
            type={props.data.StatusCeklist === "1" ? "default" : "primary"}
            onClick={async () => {
              if (
                window.confirm(
                  "Pastikan semua barang dan pesanan sudah lengkap !"
                )
              ) {
                var data = {
                  sesionId: props.data.SesionID,
                  sequence: props.data.No,
                  user: userObj.firstName,
                  action:
                    props.data.StatusCeklist === "1" ? "UNCHECK" : "CHECK",
                };
                let { affect } = await UpdateStatusPesanan(data);

                if (affect && affect > 0) {
                  notification.success({
                    message: "Update Status Pesanan",
                    description: "Status pesanan berhasil di update",
                  });
                } else {
                  notification.error({
                    message: "Update Status Pesanan",
                    description:
                      "Status pesanan gagal diupdate. Coba lagi nanti",
                  });
                }
              }
            }}
          >
            <Space>
              {props.data.StatusCeklist === "1" ? <CheckOutlined /> : ""}
              Ceklist
            </Space>
          </ClickLoadingButton>
        </Space>
      )}
      hideEdit
    />
  );
};

export default PesananSiapKirim;
